
<script>

    import ThankYouSection from "../../components/pagesbuilder/sections/ThankYouSection";
    import PreviewSection from "./PreviewSection";

    export default {
        name: "PreviewThankYouSection",
        mixins: [PreviewSection,ThankYouSection],
        data() {
            return {}
        },
    }
</script>
